<app-navbar class="d-none" *ngIf="!(location == '/coming-soon')"></app-navbar>
<router-outlet></router-outlet>
<app-footer class="d-none" *ngIf="!(location == '/coming-soon')"></app-footer>
<ngx-scrolltop></ngx-scrolltop>
